import { useRequestURL } from '#imports'

import type {
  BasePageContentAPI,
  MappedApiPageContent,
  ParentPageInfos,
} from '@backmarket/http-api/src/api-specs-content/models/base-page-content'
import type { Maybe } from '@backmarket/utils/types/Maybe'

import { formatBlock } from '../helpers/formatBlock'

export function useFormatContentResponse() {
  const currentUrl = useRequestURL()

  function formatContentResponse<P extends BasePageContentAPI>(
    response: P,
  ): MappedApiPageContent<P> {
    const pageName = response.name
    const pageType = response.type

    const apiParentPageInfos = response.parentPageInfos

    const parentPageInfos: Maybe<ParentPageInfos> = apiParentPageInfos
      ? {
          pageName: apiParentPageInfos.name,
          titleBreadcrumb: apiParentPageInfos.titleBreadcrumb,
        }
      : null

    return {
      ...response,
      parentPageInfos,
      pageName,
      pageType,
      blocks: response.blocks.map((block) => formatBlock(block, currentUrl)),
    }
  }

  return formatContentResponse
}
